import * as service from './service'

export default {
  namespace: 'widgetMallOrderPaySuccess',
  state: {
    orderInfoData: {}
  },
  effects: {

    * getOrderInfo ({ payload }, { call, put }) {
      const res = yield call(service.getOrderInfo, payload)
      yield put({
        type: 'save',
        payload: {
          orderInfoData: res.data.data
        }
      })
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
